/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_controls__aria_labels__location = /** @type {(inputs: {}) => string} */ () => {
	return `Ort`
};

const en_map_controls__aria_labels__location = /** @type {(inputs: {}) => string} */ () => {
	return `Location`
};

const es_map_controls__aria_labels__location = /** @type {(inputs: {}) => string} */ () => {
	return `Ubicación`
};

const fr_map_controls__aria_labels__location = /** @type {(inputs: {}) => string} */ () => {
	return `Localisation`
};

const it_map_controls__aria_labels__location = /** @type {(inputs: {}) => string} */ () => {
	return `Posizione`
};

const nl_map_controls__aria_labels__location = /** @type {(inputs: {}) => string} */ () => {
	return `Ligging`
};

const pt_map_controls__aria_labels__location = /** @type {(inputs: {}) => string} */ () => {
	return `Localização`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__location = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_controls__aria_labels__location(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_controls__aria_labels__location", locale)
	if (locale === "de") return de_map_controls__aria_labels__location(inputs)
	if (locale === "en") return en_map_controls__aria_labels__location(inputs)
	if (locale === "es") return es_map_controls__aria_labels__location(inputs)
	if (locale === "fr") return fr_map_controls__aria_labels__location(inputs)
	if (locale === "it") return it_map_controls__aria_labels__location(inputs)
	if (locale === "nl") return nl_map_controls__aria_labels__location(inputs)
	return pt_map_controls__aria_labels__location(inputs)
};